import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCurrentMembership } from "services/memberships";
import "blueimp-canvas-to-blob/js/canvas-to-blob";
import { ThemeProvider } from "styled-components";
import {
  validateAuthState,
  requestLoginUsernameReset,
  switchCompany,
} from "./actions/auth";
import { setTheme } from "./actions/theme";
import { THEMES } from "./theme/themes";

const App = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth_status = props.auth_status;
  const company_info = props.company_info;
  const { isAuthenticated } = auth_status;

  useEffect(() => {
    if (
      location &&
      !location.pathname.match(/passwordRegistration/) &&
      location.pathname !== "/login" &&
      location.pathname !== "/"
    ) {
      const path = location.pathname ? location.pathname : "/";
      const search = location.search ? location.search : "";
      if (!isAuthenticated) {
        props.validateAuthState(path, search);
      }
    }
    setScreenToLoading();
  }, [location, company_info, auth_status?.isAuthenticated]);

  useEffect(() => {
    handleCompanySwitch();
  }, [company_info]);

  // function updateCachedCompany() {
  //   if (company_info) {
  //     const companyInfoType = company_info.type;
  //     const prevCompanyInfoType = prevCompanyInfo?.type;

  //     if (
  //       prevCompanyInfoType !== companyInfoType &&
  //       companyInfoType === "COMPANY_INFO_REQUEST_SUCCESS"
  //     ) {
  //       const { addressPreferences: { id } = {} } = company_info;
  //       switchCompany(id);
  //     }
  //   }
  // }

  /**
   * Re-route to portal home page if user asks to switch companies
   */
  function handleCompanySwitch() {
    const { auth_status } = props;
    const { currentMembership: incomingCurrentMembership, isAuthenticated } =
      auth_status;
    const existingCurrentMembership = getCurrentMembership();

    if (
      incomingCurrentMembership !== undefined &&
      existingCurrentMembership !== undefined &&
      incomingCurrentMembership !== existingCurrentMembership
    ) {
      if (
        isAuthenticated &&
        incomingCurrentMembership !== existingCurrentMembership
      ) {
        setTimeout(() => {
          navigate("/portal");
        }, 500);
      }
    }
  }

  /**
   * Blur background if COMPANY_REQUEST api call occurs
   */
  function setScreenToLoading() {
    const pathname = location?.pathname;
    const body = document.querySelector("body");

    if (
      company_info.type === "COMPANY_INFO_REQUEST" &&
      pathname !== "/" &&
      pathname !== "/login"
    ) {
      body.classList.add("loading");
    } else if (
      company_info.type === "COMPANY_INFO_REQUEST_ERROR" ||
      company_info.type === "COMPANY_INFO_REQUEST_SUCCESS" ||
      pathname === "/" ||
      pathname === "/login"
    ) {
      body.classList.remove("loading");
    }
  }

  return (
    <ThemeProvider theme={THEMES.default}>
      <div className="App">{props.children}</div>
    </ThemeProvider>
  );
};

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    theme: state.theme,
  };
}

export default connect(mapStateToProps, {
  validateAuthState,
  requestLoginUsernameReset,
  switchCompany,
  setTheme,
})(App);
